import { render, staticRenderFns } from "./WorkoutSplitEditExerciseSingle.vue?vue&type=template&id=5c385d88&scoped=true"
import script from "./WorkoutSplitEditExerciseSingle.vue?vue&type=script&lang=js"
export * from "./WorkoutSplitEditExerciseSingle.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSplitEditExerciseSingle.vue?vue&type=style&index=0&id=5c385d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c385d88",
  null
  
)

export default component.exports